import { useState } from "react";
import { useMediaQuery } from "react-responsive";
import DesktopConfiguration from "./desktop/DesktopConfiguration";

export default function ConfigurationContainer() {
    const isMobile = useMediaQuery({
        query: "(max-width: 599px)"
    });

    return (
        <div>
            {!isMobile && <DesktopConfiguration />}
            {isMobile && <div style={{ padding: "20px", textAlign: "center" }}>Mobile version coming soon</div>}
        </div>
    );
}
